<div class="table-header">
  <div class="header">
    <h5>
      <ng-content select="[toolbarIcon]"></ng-content>
      @if (icon(); as titleIcon) {
        <fa-icon [icon]="titleIcon"></fa-icon>
      }
      {{ title() }}
    </h5>

    @if (tabs().length > 0) {
      <div
        ngpTabset
        class="grid-toolbar-tabs"
        [ngpTabsetValue]="activeTabId() ?? ''"
        (ngpTabsetValueChange)="tabChange.emit($event)"
      >
        <div
          ngpTabList
          class="grid-toolbar-tabs__list"
          [attr.aria-label]="tabsLabel()"
        >
          @for (tab of tabs(); track tab.id) {
            <div class="grid-toolbar-tabs__item">
              <button
                type="button"
                ngpTabButton
                class="grid-toolbar-tabs__tab"
                [ngpTabButtonValue]="tab.id"
              >
                {{ tab.label }}
              </button>
              @if (tab.removable) {
                <sui-button
                  class="grid-toolbar-tabs__remove"
                  variant="ghost"
                  size="xsm"
                  [iconOnly]="true"
                  [leadingIcon]="['fas', 'xmark']"
                  [ariaLabel]="tabRemoveLabel()"
                  [suiTooltip]="tabRemoveLabel()"
                  (click)="tabRemove.emit(tab.id)"
                ></sui-button>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  @if (ready()) {
    <sui-toolbar #tb class="toolbar">
      @if (loading() || count() !== null) {
        <div class="counter">
          @if (loading()) {
            <app-loading [size]="'1x'" [centered]="false"></app-loading>
          } @else {
            {{ count() | number }} {{ "grid.toolbar.items" | translate }}
          }
        </div>
      }

      <!-- Feed-style page jumping over the server-side row model -->
      @if (showPagination()) {
        <div class="toolbar-pagination">
          <sui-pagination
            [collectionSize]="collectionSize()"
            [currentPage]="currentPage()"
            [pageSize]="pageSize()"
            (pageChanged)="pageChange.emit($event)"
            (doPageChange)="pageChange.emit(+$event)"
          ></sui-pagination>
        </div>
      }

      <ng-content select="[toolbarStatus]"></ng-content>

      <!-- The view's own feature actions, left of the shared controls -->
      <div class="toolbar-actions">
        <ng-content select="[toolbarActions]"></ng-content>
      </div>

      <div class="view-options">
        @if (showRefresh()) {
          <sui-button
            variant="secondary"
            [leadingIcon]="['fas', 'sync']"
            [iconOnly]="tb.collapsed()"
            [ariaLabel]="
              tb.collapsed() ? ('btn.refresh' | translate) : undefined
            "
            [suiTooltip]="
              'grid.toolbar.tooltip.reload-the-grid-data' | translate
            "
            (click)="refresh.emit()"
          >
            {{ tb.collapsed() ? "" : ("btn.refresh" | translate) }}
          </sui-button>
        }

        @if (showResetFilters()) {
          <sui-button
            variant="secondary"
            [leadingIcon]="['fas', 'filter-circle-xmark']"
            [iconOnly]="tb.collapsed()"
            [ariaLabel]="
              tb.collapsed() ? ('btn.reset-filters' | translate) : undefined
            "
            [suiTooltip]="
              'grid.toolbar.tooltip.clear-all-column-filters' | translate
            "
            (click)="resetFilters.emit()"
          >
            {{ tb.collapsed() ? "" : ("btn.reset-filters" | translate) }}
          </sui-button>
        }

        @if (showExport()) {
          <div class="actions-dropdown">
            <sui-button
              variant="secondary"
              [leadingIcon]="['fas', 'file-export']"
              [iconOnly]="tb.collapsed()"
              [ariaLabel]="
                tb.collapsed() ? ('btn.export' | translate) : undefined
              "
              [trailingIcon]="['fas', 'caret-down']"
              [expanded]="exportDropdown.isOpen()"
              [suiTooltip]="'grid.toolbar.tooltip.export-the-grid' | translate"
              [suiMenuTrigger]="exportMenu"
              #exportDropdown="suiMenu"
            >
              {{ tb.collapsed() ? "" : ("btn.export" | translate) }}
            </sui-button>

            <ng-template #exportMenu>
              <sui-menu>
                @if (showExportCsv()) {
                  <button sui-menu-item (click)="exportCsv.emit()">
                    <fa-icon [icon]="['fas', 'file-csv']"></fa-icon>
                    <span>{{ "grid.toolbar.export-csv" | translate }}</span>
                  </button>
                }
                @if (showExportCsvServerSide()) {
                  <button sui-menu-item (click)="exportCsvServerSide.emit()">
                    <fa-icon [icon]="['fas', 'file-csv']"></fa-icon>
                    <span>{{
                      "grid.toolbar.export-csv-serverside" | translate
                    }}</span>
                  </button>
                }
              </sui-menu>
            </ng-template>
          </div>
        }

        <ng-content select="[toolbarViewOptions]"></ng-content>
      </div>
    </sui-toolbar>
  }
</div>
